// AI Generated
import { Component, Input } from '@angular/core';

@Component({
    selector: 'seo-information-too-short-meta-description',
    standalone: false,
    template: `
        <h5>
            <span translate
                  translate-plural="META descriptions on this page"
                  [translate-n]="count(seo.content)">
                There is one META description on this page
            </span>
            ( {{ countCharacters(seo.content) }}
            <span translate
                  translate-plural="Characters"
                  [translate-n]="countCharacters(seo.content)">
                Character
            </span>)
        </h5>

        <ul class="list-unstyled">
            <li *ngFor="let description of seo.content; trackBy: trackByIndex">{{ description }}</li>
        </ul>
    `,
})
export class SeoInformationTooShortMetaDescriptionComponent {
    @Input() seo: any;

    count (content: any): number {
        if (Array.isArray(content)) {
            return content.length;
        } else if (content === null || content === undefined) {
            return 0;
        }

        return 1;
    }

    countCharacters (content: any): number {
        if (Array.isArray(content)) {
            return content.reduce((a: number, b: string) => {
                return a + b.length;
            }, 0);
        }
        return 0;
    }

    trackByIndex (index: number): number {
        return index;
    }
}
